import MuiMenuItem, { MenuItemProps } from "@mui/material/MenuItem";

const MenuItem: React.FC<MenuItemProps> = MuiMenuItem;

export default MenuItem;

export type { MenuItemProps };
